<template>
  <div class="description-container">
    <div class="published" :style="styles">
      {{ postDate() }}
    </div>
    <div class="description" :style="styles">
      <span v-html="parseText"></span>
      <span v-if="showMore" @click="toggleMore()" class="more-Link more"
        >more...</span
      >
    </div>
  </div>
</template>

<script>
import { dateTimeAgo } from '@/helper/Format'
import { convertEmToPixels } from '@/helper/helper'
// import { browserLog } from '../../helper/helper'
export default {
  created: function () {
    this.txtParts = this.description.split('~')
    this.showMore = this.txtParts[0] !== this.description
  },
  name: 'Description',
  props: {
    published_at: {
      type: Object,
      default () {
        return {}
      }
    },
    description: String
  },
  data: () => ({
    showMore: true,
    txtParts: []
  }),
  computed: {
    parseText () {
      return this.showMore ? this.txtParts[0] : this.txtParts.join('')
    },
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    postDate () {
      return dateTimeAgo(this.published_at)
    },
    toggleMore () {
      this.showMore = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/description.vue